import router from '../router'
import { logout } from '@/utils/auth'
import Vue from 'vue'

export function onFulfilled(response) {
    return response
}

export function onRejected(error) {
    if (error.response && 401 === error.response.status) {
        //If we get a 401 they timed out or are likely doing something they shouldn't, kick them out
        logout()
        router.push({ name: 'Login' })
    } else if ('Network Error' === error.message) {
        //If we get a Network Error we'll create a response as if we got one from the server so our client side error handling will work as if we did connect
        Vue.prototype.$log.error("Unable to connect to the API")
        return Promise.reject({
            response: {
                data: {
                    message: 'The Self-Reporting system is currently unavailable. Please try again later. If the problem persists, please contact your account manager.'
                }
            }
        })
    }
    return Promise.reject(error)
}
